module.exports = __webpack_public_path__ + "static/media/operator.b818a814.svg";